import React from 'react'
import styled from 'styled-components'
import ItemImage from '../../_common/ItemImage'
import { Link } from 'react-router-dom'

const PartTitle = styled.div`
    font-weight: 700;
`
/*A container is necessary for <ItemImage> because it auto-sizes itself to 100% w&h*/
const PartImageDiv = styled.div`
    width: 75px;
    height: 75px;
`

const relationsKey = {
    1: 'Spare Part',
    2: 'Accessory',
    3: 'Replacement',
    4: 'Bill of Materials'
}

export default function RelatedItem(props) {
    const {
        itemCode,
        invMastUid,
        itemCodeUrlSanitized,
        type,
        isAssembly,
        isNcnr,
        itemMedia
    } = props

    const itemLink = `/product/${itemCodeUrlSanitized}/${invMastUid}`;

    return (
        <tr>
            <td>
                {relationsKey[type]}
            </td>
            <td>
                <PartTitle>
                    <Link to={itemLink}>{itemCode}</Link>
                </PartTitle>
            </td>
            <td>
                <PartImageDiv>
                    <Link to={itemLink}>
                        <ItemImage {...{
                            size: 'thumbnail',
                            lazy: true,
                            details: {
                                itemCode,
                                invMastUid,
                                isAssembly,
                                isNcnr,
                                itemMedia
                            }
                        }} />
                    </Link>
                </PartImageDiv>
            </td>
        </tr>
    )
}
